import { render } from "./mentions_line.vue?vue&type=template&id=3e3ac2b3"
import script from "./mentions_line.js?vue&type=script&lang=js"
export * from "./mentions_line.js?vue&type=script&lang=js"

import "./mentions_line.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/opt/pleroma-fe/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__